var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_2135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 13.45C22.3 13.2025 22.5025 13 22.75 13H26.35C26.5975 13 26.8 13.2025 26.8 13.45V13.9H30.4C31.8906 13.9 33.1 15.1094 33.1 16.6C33.1 17.0978 32.6978 17.5 32.2 17.5H26.8V24.7H23.155C23.1831 24.8462 23.2 24.9953 23.2 25.15C23.2 26.3931 22.1931 27.4 20.95 27.4C19.7069 27.4 18.7 26.3931 18.7 25.15C18.7 24.9953 18.7169 24.8462 18.745 24.7H18.7L16.5259 22.5259C16.1884 22.1884 16 21.7328 16 21.2547V15.7C16 14.7072 16.8072 13.9 17.8 13.9H22.3V13.45ZM19.15 16.6C18.9025 16.6 18.7 16.8025 18.7 17.05V18.85C18.7 19.0975 18.9025 19.3 19.15 19.3H22.75C22.9975 19.3 23.2 19.0975 23.2 18.85V17.05C23.2 16.8025 22.9975 16.6 22.75 16.6H19.15ZM21.85 25.15C21.85 24.6522 21.4478 24.25 20.95 24.25C20.4522 24.25 20.05 24.6522 20.05 25.15C20.05 25.6478 20.4522 26.05 20.95 26.05C21.4478 26.05 21.85 25.6478 21.85 25.15ZM29.95 26.05C30.4478 26.05 30.85 25.6478 30.85 25.15C30.85 24.9644 30.7937 24.79 30.6953 24.6466C30.535 24.4075 30.2594 24.25 29.95 24.25C29.6181 24.25 29.3256 24.43 29.1709 24.7C29.095 24.8322 29.05 24.9869 29.05 25.15C29.05 25.6478 29.4522 26.05 29.95 26.05ZM27.7 24.7V24.25V22V21.1V19.075V18.4H28.375H30.5294C30.8922 18.4 31.2466 18.5266 31.5278 18.7572L33.4234 20.3097C33.7891 20.6078 34 21.055 34 21.5275V22V23.8C34 24.2978 33.5978 24.7 33.1 24.7H32.155C32.1831 24.8462 32.2 24.9953 32.2 25.15C32.2 26.3931 31.1931 27.4 29.95 27.4C28.7069 27.4 27.7 26.3931 27.7 25.15V24.7ZM32.2591 21.1L30.67 19.8006C30.6306 19.7669 30.58 19.75 30.5266 19.75H29.05V21.1H32.2591Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_2135",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_2135"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRv);
export default __webpack_public_path__ + "static/media/rv.59745f3a3ea1335e0cd85d836ef7fc84.svg";
export { ForwardRef as ReactComponent };